export const defaultSearchCondition = (row: any, search: string) => {
  if (row?.name && typeof row.name === 'string') {
    return row.name.toLowerCase().includes(search.toLowerCase());
  }
  return false
}